// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"WrittenText_textWrapper__oZ7oz","blink":"WrittenText_blink__NmYg7"};